import React from 'react';
import useStyles from './style';

const index = ({ onClick, user }) => {
  const classes = useStyles();

  return (
    <div className={classes.aiLearning_div}>
      <h1 className={classes.aiLearning_h1}>Welcome to SuperReach Learning, {user?.fname}!</h1>
      <h3 className={classes.aiLearning_h3}>
        Unlock your full sales potential through expert training, beat the bot AI Roleplays and
        more!
      </h3>
      <div className={classes.aiLearning_iframe}>
        <iframe
          src="https://gnxplayer.html5.run/?vod=Welcome_To_SR_Learning_1"
          playsInline=""
          allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; encrypted-media"
          style={{ width: '100%', height: '100%', position: 'relative', border: 'none' }}
        ></iframe>
      </div>
      <span className={classes.aiLearning_span} onClick={onClick}>
        I’ll do this later, thanks!
      </span>
    </div>
  );
};

export default index;
